import OcppTagsTable from '../organisms/OcppTagsTable/OcppTagsTable';

const OcppTagListPage = () => <OcppTagsTable />;

export default OcppTagListPage;
